





















































import { Nationality } from '@core/services/authentication/_private/Types';
import { UserService } from '@core/services/user/UserService';
import {
    SdsAlert,
    SdsButton,
    SdsInputDropdown,
    SdsSelect,
} from '@superbet-group/web.lib.ui-components';
import {
    useI18n,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    defineComponent,
    Ref,
    ref,
    watch,
} from '@vue/composition-api';
import authStore from '@store/modules/data/authentication/authenticationIndex';
import { captiveKycStore } from '@accountFederation/store/data/captiveKyc/captiveKycStore';

export default defineComponent({
    name: 'BrMigrationComplete',
    setup() {
        const { translate } = useI18n();
        const selectedGender = ref('');

        // TODO: Move repeated gender options to a shared source
        const genderOptions = [
            { value: 'M', name: translate('pam.genderSelect.male') },
            { value: 'F', name: translate('pam.genderSelect.female') },
            { value: 'O', name: translate('pam.genderSelect.other') },
        ];
        const selectedNationality = ref('');
        const nationalityOptions: Ref<Nationality[]> = ref([]);
        const errorMessage = ref('');
        const isLoading = ref(false);

        let loadedNationalities = false;
        const loadNationalities = async () => {
            if (loadedNationalities) {
                return;
            }
            // TODO: Cleanup this import across the project, currently it's eagerly loaded anyway
            const nationalities: Nationality[] = (await import('@accountFederation/countries/br/registration/nationalities')).default;
            nationalityOptions.value = nationalities.map((nationality) => ({ value: nationality.code, name: nationality.name, code: nationality.code }));
            // eslint-disable-next-line require-atomic-updates
            loadedNationalities = true;
        };

        const authModule = useVuexStore<typeof authStore>('data/authentication');
        const setUserData = authModule.action('setUserData');

        const captiveKycModule = useVuexStore<typeof captiveKycStore>('data/captiveKyc');
        const hasIncompleteVerification = captiveKycModule.getter('hasIncompleteVerification');
        const maybeRedirectToKyc = captiveKycModule.action('maybeRedirectToCaptiveKyc');
        const freeFromCaptiveKyc = captiveKycModule.action('freeFromCaptiveKyc');

        const submitUpdate = async () => {
            try {
                isLoading.value = true;
                await UserService.getInstance().updateBrasilMigrationDetails(selectedGender.value, selectedNationality.value);

                setUserData({
                    key: 'gender',
                    value: selectedGender.value,
                });

                setUserData({
                    key: 'nationality',
                    value: selectedNationality.value,
                });

                if (hasIncompleteVerification.value) {
                    maybeRedirectToKyc();
                } else {
                    freeFromCaptiveKyc({
                        shouldRedirect: true,
                    });
                }
            } catch (e) {
                errorMessage.value = 'Something went wrong. Please try again';
            } finally {
                isLoading.value = false;
            }
        };

        watch(() => selectedGender.value, (newValue) => {
            if (newValue !== selectedGender.value) {
                errorMessage.value = '';
            }
        });

        watch(() => selectedNationality.value, (newValue) => {
            if (newValue !== selectedNationality.value) {
                errorMessage.value = '';
            }
        });

        const isContinueDisabled = computed(() => !selectedGender.value || !selectedNationality.value);

        return {
            errorMessage,
            genderOptions,
            selectedGender,
            nationalityOptions,
            selectedNationality,
            isContinueDisabled,
            isLoading,
            loadNationalities,
            submitUpdate,
        };
    },
    components: {
        SdsSelect,
        SdsButton,
        SdsAlert,
        SdsInputDropdown,
    },
});
